var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace55(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 86 85",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.686 75.948C24.131 75.947 9.091 60.971 9.091 42.499c0-18.473 15.04-33.449 33.595-33.449 18.553 0 33.594 14.976 33.594 33.449S61.239 75.948 42.686 75.948m0-75.948C19.112 0 0 19.027 0 42.5c0 23.471 19.112 42.499 42.686 42.499s42.685-19.028 42.685-42.5S66.259 0 42.685 0",
    fill: "#1f355e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.28 42.5c0 18.645-15.041 33.761-33.594 33.761-18.555 0-33.595-15.116-33.595-33.761 0-18.646 15.04-33.762 33.595-33.762 18.553 0 33.594 15.116 33.594 33.762",
    fill: "#ff3b3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.823 61.961a1.002 1.002 0 01-.736-.306c-.327-.351-.256-.865.143-1.15 26.388-18.407 47.102-.115 47.306.076.359.323.348.836-.03 1.151-.379.315-.971.306-1.33-.019-.797-.722-19.762-17.388-44.781.067a.942.942 0 01-.572.18M68.686 40.188c0 2.668-2.318 4.831-5.178 4.831-2.859 0-5.175-2.163-5.175-4.831 0-2.668 2.316-4.831 5.175-4.831 2.86 0 5.178 2.163 5.178 4.831M28.754 40.188c0 2.668-2.316 4.831-5.175 4.831-2.862 0-5.178-2.163-5.178-4.831 0-2.668 2.316-4.831 5.178-4.831 2.849 0 5.175 2.163 5.175 4.831",
    fill: "#1f355e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.585 27.739l7.734 5.838",
    fill: "none",
    stroke: "#1f355e",
    strokeWidth: 2.22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.618 26.812l-7.099 6.538",
    fill: "none",
    stroke: "#1f355e",
    strokeWidth: 2.23
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace55);
export default __webpack_public_path__ + "static/media/face55.e19927e0f89704f64f7d1da4fea03bbe.svg";
export { ForwardRef as ReactComponent };